import {call, put} from "@redux-saga/core/effects";
import deltas from "../../../../redux/actions/deltas";
import request from "../../../helpers/request";
import {getAllEnrolments, getAllCohorts} from "../../../../api";
import pollingEnrolmentsAndCohortsStates from "../../../../redux/states/pollingEnrolmentsAndCohorts"
import reloadingEnrolmentsAndCohortsStates from "../../../../redux/states/reloadingEnrolmentsAndCohorts"
import {all, select} from "redux-saga/effects";

const {
    setPollingEnrolmentsAndCohortsState,
    setEnrolments,
    setCohorts,
    setReloadingEnrolmentsAndCohortsState,
    setLastUpdatedAt,
    setEnrolmentsGridCurrentPage,
    setEnrolmentsPaginationData,
} = deltas.actionCreators;

const {
    NO_UPDATE_NEEDED,
} = pollingEnrolmentsAndCohortsStates;

const {
    LOADING,
    NOT_LOADING,
} = reloadingEnrolmentsAndCohortsStates;

const options = {
    notificationOnFailure: {
        generateMessage: message => 'There was a problem reloading the data',
    }
};

export default function* reloadEnrolmentsAndCohorts(filterChanged = false) {

    if ( filterChanged ) {
        yield put(setEnrolmentsGridCurrentPage(1));
    }

    const state = yield select();

    let currentPage = state.enrolmentsGrid.currentPage;

    if (['previous', 'next'].includes(currentPage)) {
        yield put(setEnrolmentsGridCurrentPage(1));
        currentPage = 1;
    }

    let sorters = [];

    for (const [key, value] of Object.entries(state.enrolmentsGrid.sorters)) {
        sorters.push([value['column'], value['direction']]);
    }

    const sortersJSON = JSON.stringify(sorters);

    let filters = Object.entries(state.enrolmentsGrid.filters);

    const filtersJSON = JSON.stringify(filters);

    yield put(setReloadingEnrolmentsAndCohortsState(LOADING));

    const {
        enrolments: {response: {data: enrolments}},
        cohorts: {response: {data: cohorts}},
    } = yield all({
        enrolments: call(request, ...[getAllEnrolments, options, {}, null, {'sortInstructions':`${sortersJSON}`, 'filterInstructions':`${filtersJSON}`, 'currentPage': `${currentPage}`}]),
        cohorts: call(request, ...[getAllCohorts, options]),
    });

    yield put(setEnrolments(enrolments.rows));
    yield put(setLastUpdatedAt({data: enrolments.lastUpdatedAt}));
    yield put(setEnrolmentsPaginationData({totalPages: enrolments.totalPages, currentCount: enrolments.currentCount, totalCount: enrolments.totalCount}));
    yield put(setCohorts(cohorts));
    yield put(setPollingEnrolmentsAndCohortsState(NO_UPDATE_NEEDED));
    yield put(setReloadingEnrolmentsAndCohortsState(NOT_LOADING));
}
